<template>
  <div id="logo-img-div">
    <img src="../assets/images/logos/PetPlayPalsBanner.png" alt="Pet Play Pals Logo Banner">
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  div > img {
    margin: auto;
    max-width: 95vw;
    max-height: 10vh;
    min-height: 5vh;
  }
</style>